import React from 'react';

export const Options = ({ width = 16, height = 14 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 12C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H1C0.447715 14 0 13.5523 0 13C0 12.4477 0.447715 12 1 12H15ZM15 8C15.5523 8 16 8.44771 16 9C16 9.55229 15.5523 10 15 10H1C0.447715 10 0 9.55229 0 9C0 8.44771 0.447715 8 1 8H15ZM15 4C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H1C0.447715 6 0 5.55228 0 5C0 4.44772 0.447715 4 1 4H15ZM15 0C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H15Z"
        fill="white"
      />
    </svg>
  );
};
